import { render, staticRenderFns } from "./notionInvestment.vue?vue&type=template&id=5d21d857&scoped=true&"
import script from "./notionInvestment.vue?vue&type=script&lang=js&"
export * from "./notionInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21d857",
  null
  
)

export default component.exports